import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    strict: true, // 开启严格模式  确保state 中的数据只能 mutations 修改
    state: {
        mineChangeRed: null
    },
    mutations: { //修改数据仓库的事件
        changeMineChangeRed(state, value) {
            state.mineChangeRed = value
        }
    },
    actions: { //推荐使用的异步修改数据仓库
        setMineChangeRed(context, value) {
            context.commit('changeMineChangeRed', value)
        }
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js